const animalSummaryRoute = (animalId, tab) => ({
  path: `/animals/${animalId}/full-summary`,
  state: { activeTab: tab || 'snapshot' },
});

export const getGlobalSearchRoute = (item) => {
  if (!item?.type) {
    return null;
  }

  if (item.animal_id) {
    return animalSummaryRoute(item.animal_id, item.tab);
  }

  if (item.group_id) {
    return `/animal-groups/${item.group_id}/preview`;
  }

  switch (item.type) {
    case 'animal':
      return `/animals/${item.id}/full-summary`;
    case 'animal_group':
      return `/animal-groups/${item.id}/preview`;
    case 'feedlot_batch':
      return `/feedlots/${item.id}/preview`;
    case 'farm':
      return `/farms/${item.id}/edit`;
    case 'contact':
      return `/contacts/${item.id}/edit`;
    case 'inventory':
      return `/inventory/${item.id}/edit`;
    case 'warehouse':
      return `/inventory/warehouses/${item.id}`;
    case 'zone':
      return `/zones/${item.id}/edit`;
    case 'shed':
      return `/sheds/${item.id}/edit`;
    case 'lot':
      return `/lots/${item.id}/edit`;
    case 'pen':
      return `/pens/${item.id}/edit`;
    case 'task':
      return '/tasks';
    case 'alert':
      return `/alerts/${item.id}`;
    case 'sale':
      return '/sales';
    case 'user':
      return `/team/${item.id}/edit`;
    case 'treatment':
      return '/health';
    case 'feed':
      return '/feeding';
    case 'measurement':
      return '/measurements';
    case 'breeding':
      return '/breeding';
    case 'yield':
      return '/milking';
    case 'milking':
      return '/milking';
    case 'input':
      return '/activities?activity=inputs';
    case 'grazing':
      return '/grazing';
    case 'movement':
      return '/movement';
    case 'note':
      return '/activities?activity=notes';
    case 'schedule':
      return '/schedule';
    case 'feed_formulation':
      return `/feed-formulations/${item.id}/edit`;
    case 'wastage':
      return '/wastage';
    case 'department':
      return `/departments/${item.id}/edit`;
    case 'cost_centre':
      return `/cost-centres/${item.id}/edit`;
    case 'account':
      return `/chart-of-accounts/${item.id}/edit`;
    case 'expense':
      return '/other-charges';
    case 'revenue':
      return '/other-charges';
    case 'accounting':
      return '/accounting-ledgers';
    case 'payroll':
      return '/payroll';
    case 'roster':
      return '/roster';
    case 'visitor':
      return '/visitors';
    case 'equipment':
      return '/maintenance/equipment';
    case 'maintenance_schedule':
      return '/maintenance/schedules';
    case 'security':
      return '/security';
    default:
      return null;
  }
};
